import axios from "axios";

const instance = axios.create({
  baseURL:"https://api.binhaider.amazing7studios.com",
  // baseURL:"http://10.0.0.58:3000",
  // baseURL:"http://localhost:4000",

  headers:{
    timeout:1000,
  }
})

// The token used to be read once at module load and frozen onto the instance's
// default headers, which meant the app had to do a full page load for a fresh
// token to take effect. Reading it per request lets pages navigate in-app.
instance.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("admin_token_validation")
  if (token && token !== "undefined" && token !== "null") {
    config.headers.Authorization = `Bearer ${token}`
  } else {
    delete config.headers.Authorization
  }
  return config
})

export default instance;
